export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";